import get from 'lodash/get';

const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';

const PHONE = 'phone';

const TABLET = 'tablet';

const DESKTOP = 'desktop';

const defaultState = {
  is: {
    small: false,
    medium: false,
    large: true
  }
};

const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case SET_DEVICE_TYPE: {
      const { type, cloudflare } = get(action, 'payload.device') || {};
      const resolved = cloudflare || type;

      return {
        is: {
          small: ['phone', 'mobile'].includes(resolved),
          medium: resolved === 'tablet',
          large: resolved === 'desktop'
        }
      };
    }
    default:
      return state;
  }
};

const setDeviceType = device => ({
  type: SET_DEVICE_TYPE,
  payload: { device }
});

export {
  SET_DEVICE_TYPE,
  PHONE,
  TABLET,
  DESKTOP,
  defaultState,
  reducer,
  setDeviceType
};
